import * as Yup from "yup";

/**
 * Six digits.
 *
 * The rule used to be `/^(\d\s{3}){5}\d$/` — six digits separated by exactly
 * three spaces — because the field was a masked input whose value carried the
 * mask's own whitespace, and its message quoted that shape back at the
 * reader: 'OTP should be in the format: "1   2   3   4   5   6"'. Nobody
 * types spaces into a code box, and with the six-cell CodeInput the value is
 * just the digits, so the rule is what it always meant.
 */
export const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .required("Enter the six-digit code")
    .matches(/^\d{6}$/, "The code is six digits"),
});
